import { type MessageState, useMessageStore } from "@/state/stores";

export function selectVersionInformationFromState(
  state: MessageState,
  versionNumber: number | undefined,
) {
  for (const versionId in state.versionInformation) {
    const versionInfo = state.versionInformation[versionId];
    if (versionInfo.version === versionNumber) {
      return versionInfo;
    }
  }

  return null;
}

export function useVersionInformation(versionNumber: number) {
  return useMessageStore((state) =>
    selectVersionInformationFromState(state, versionNumber),
  );
}

export function useVersionInformationSpec(versionNumber: number) {
  return useMessageStore(
    (state) => selectVersionInformationFromState(state, versionNumber)?.spec,
  );
}

export function useVersionInformationFiles(versionNumber: number) {
  return useMessageStore(
    (state) => selectVersionInformationFromState(state, versionNumber)?.files,
  );
}

export function useLatestVersionNumber(): number | undefined {
  return useMessageStore((state) => {
    const versionsValues = Object.values(state.versionInformation)
      .map((version) => version.version)
      .sort((a, b) => a - b);
    return versionsValues[versionsValues.length - 1];
  });
}
